import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { api } from 'src/common/utils/api';
import { useFileUploadMutation } from 'src/data-capture/hooks/useFileUploadMutation';
import { Logger } from 'src/utils/Logger';
import { CompanyDocument } from '../types';

export const useCreateCompanyDocument = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { uploadToFileStorage } = useFileUploadMutation();
  const queryClient = useQueryClient();

  const createCompanyDocument = async (file: File) => {
    try {
      setIsLoading(true);
      await uploadToFileStorage({ file, subfolder: 'appendices' });
      await api.post<CompanyDocument>('company-documents', {
        file: {
          fileName: file.name,
          fileSize: file.size,
          fileType: file.type,
          subfolder: 'appendices',
        },
      });
      queryClient.invalidateQueries({ queryKey: ['company-documents'] });
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      Logger.error('Failed to upload company document', e);
      throw e;
    }
  };

  return {
    createCompanyDocument,
    isLoading,
  };
};
